import { render, staticRenderFns } from "./androidYearChange.vue?vue&type=template&id=a2231a8a&scoped=true&"
import script from "./androidYearChange.vue?vue&type=script&lang=js&"
export * from "./androidYearChange.vue?vue&type=script&lang=js&"
import style0 from "./androidYearChange.vue?vue&type=style&index=0&id=a2231a8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2231a8a",
  null
  
)

export default component.exports